<div id="report-dialog-container">
  <div class="flex-end">
    <button mat-icon-button color="warn" (click)="closeDialog()">
      <mat-icon svgIcon="close-circle"></mat-icon>
    </button>
  </div>
  <div class="title margin-vertical-1 black">
    <div [outerHTML]="data.title | translate"></div>
  </div>

  <form [formGroup]="form" (ngSubmit)="sendForm()">
    <mat-form-field appearance="fill" class="black">
      <textarea matInput formControlName="text"></textarea>
    </mat-form-field>
    <button
      mat-raised-button
      color="primary"
      class="width-50 margin-top-1 margin-bottom-2 padding-05 col-5"
      [disabled]="form.invalid"
      type="submit"
    >
      <span>{{ "send" | translate }}</span>
    </button>
  </form>
</div>
